<template>
  <footer>
    <div id="global-footer-nav-region">
      <div class="sfi-static-footer">
        <div class="container sfi-static-footer-content">
          <logo class="footer-generic-logo" :imgMarginTop="logoMarginTop" :imgWidth="logoWidth"></logo>
          <div class="sfi-footer-middle-text">
            <div class="copyright">
              <span>
                &copy; Copyright {{ insuranceType.name }}.
              </span>
              <span>
                 All Rights Reserved.
              </span>
            </div>
            <span class="policy">
              <a :href="insuranceType.privacyPolicyLink" target="_blank">Privacy Policy</a>
              |
              <a :href="insuranceType.termsOfUseLink" target="_blank">Terms of Use</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// Utils
import { mapGetters, mapState } from 'vuex';

// Constants
import constants from '@/i18n/en/constants';

export default {
  name: 'SfiFooter',
  data() {
    return {
      logoPosition: constants.logoPosition
    }
  },
  computed: {
    ...mapState(['insuranceType']),
    ...mapGetters({
      insuranceIsSfm: 'GET_IS_INSURANCE_SFM'
    }),
    logoMarginTop() {
      return this.logoPosition[this.insuranceType.key].footer.marginTop;
    },
    logoWidth() {
      return this.logoPosition[this.insuranceType.key].footer.width;
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables.scss';

#global-footer-nav-region {

  box-shadow: 0px 10px 40px 0px rgba(0,0,0,0.25);

  .sfi-static-footer {
    background: $button-background-hover;
  }

  .sfi-static-footer-content {
    max-width: $sfi-max-header-and-footer-width;
    margin: auto;
    display: flex;
    padding-bottom: 30px;
    position: relative;

    @include breakpoint(small only) {
      display: block;
      position: static;
      text-align: center;
      margin: 0;
      padding-left: 0;
      margin-left: 20px;
      margin-right: 20px;
    }

    @include breakpoint(medium only) {
      position: static;
      margin-left: 34px;
      margin-right: 34px;
    }

    .footer-generic-logo {

      img {
        position: absolute;

        @include breakpoint(small only) {
          position: static;
        }

        @include breakpoint(medium only) {
          position: static;
        }
      }

    }

    .sfi-footer-middle-text {
      color: $white;
      font-size: 14px;
      margin: auto;
      padding-left: 34px;

      @include breakpoint(small only) {
        margin-left: 0;
      }

      @include breakpoint(medium only) {
        margin-left: 31px;
        padding-left: 0;
      }
    }

    .copyright {
      margin-top: 30px;
      margin-bottom: 4px;

      @include breakpoint(small only) {
        margin-top: 25px;
      }
    }

    .policy {
      display: block;
      text-align: center;

      @include breakpoint(medium only) {
        text-align: inherit;
      }

      @include breakpoint(small only) {
        margin-top: 8px;
      }

    }

    span {
      @include breakpoint(small only) {
        display: flex;
        justify-content: center;
      }
    }

    .policy a, a:active, a:hover, a:focus, a:visited {
      font-weight: 600;
      color: $white;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/sfi-footer.vue